const DEFAULT_DEV_TRACES_SAMPLE_RATE = 1;
const DEFAULT_PROD_TRACES_SAMPLE_RATE = 0.1;

export function resolveSentryEnvironment(): string {
  return process.env.NODE_ENV || "production";
}

function resolveDefaultSentryTracesSampleRate(): number {
  return process.env.NODE_ENV === "development"
    ? DEFAULT_DEV_TRACES_SAMPLE_RATE
    : DEFAULT_PROD_TRACES_SAMPLE_RATE;
}

export function resolveSentryTracesSampleRate(
  value = process.env.NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE
): number {
  if (value !== undefined) {
    const normalizedValue = value.trim();
    if (normalizedValue.length === 0) {
      return resolveDefaultSentryTracesSampleRate();
    }

    const parsed = Number(normalizedValue);
    if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 1) {
      return parsed;
    }

    console.warn(
      `Invalid NEXT_PUBLIC_SENTRY_TRACES_SAMPLE_RATE "${value}", expected 0-1. Using default.`
    );
  }

  return resolveDefaultSentryTracesSampleRate();
}
